<br />
<br />

<mat-sidenav-container>
  <mat-sidenav id="sidenav" #sidenav mode="side" position="end">
    <visor-ine
      *ngIf="id_empleado"
      [idEmpleado]="id_empleado"
      #visorIne
    ></visor-ine>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-tab-group>
      <mat-tab label="PENDIENTES">
        <div class="inicio">
          <p class="titulo">
            {{ nombre }} {{ apellidos }}
            <button
              mat-mini-fab
              color="primary"
              (click)="clickMasInformacionV1($event)"
              matTooltip="Click para más información"
            >
              <mat-icon>info</mat-icon>
            </button>
            <br />
            <button
              mat-raised-button
              color="primary"
              matTooltip="Ver INE"
              (click)="sidenav.toggle()"
              [disabled]="!id_empleado || !visorIne?.archivo"
            >
              <mat-icon>credit_card</mat-icon> Ver identificación
            </button>
          </p>
          <table mat-table [dataSource]="dataSourceRP" class="mat-elevation-z8">
            <ng-container matColumnDef="OPCIONES">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <button
                  mat-mini-fab
                  matTooltip="Ver registro de asignación a detalle"
                  color="primary"
                  (click)="
                    clickDetallAsignacion(
                      element.administrador_TI,
                      element.colaborador_id,
                      element.id_registro_asignacion
                    )
                  "
                >
                  <mat-icon>visibility</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="RAZON">
              <th mat-header-cell *matHeaderCellDef>RAZON</th>
              <td mat-cell *matCellDef="let element">{{ element.razon }}</td>
            </ng-container>

            <ng-container matColumnDef="FECHA ASIGNACIÓN">
              <th mat-header-cell *matHeaderCellDef>FECHA ASIGNACIÓN</th>
              <td mat-cell *matCellDef="let element">
                {{ element.fecha_asignacion_cadena }}
              </td>
            </ng-container>

            <ng-container matColumnDef="CUENTA CON SOLICITUD">
              <th mat-header-cell *matHeaderCellDef>CUENTA CON SOLICITUD</th>
              <td mat-cell *matCellDef="let element">
                {{ element.cuenta_solicitud }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="encabezadosP"></tr>
            <tr mat-row *matRowDef="let row; columns: encabezadosP"></tr>
          </table>
          <mat-paginator
            #paginatorRP
            class="mat-elevation-z8"
            [pageSizeOptions]="[10, 20, 30, 40, 50]"
            showFirstLastButtons
          ></mat-paginator>
        </div>
      </mat-tab>

      <mat-tab label="REGISTROS">
        <div class="inicio">
          <p class="titulo">
            {{ nombre }} {{ apellidos }}
            <button
              mat-mini-fab
              matTooltip="Click para más información"
              color="primary"
              (click)="clickMasInformacionV2($event)"
            >
              <mat-icon>info</mat-icon>
            </button>
            <br />
            <button
              mat-raised-button
              color="primary"
              matTooltip="Ver INE"
              (click)="sidenav.toggle()"
              [disabled]="!id_empleado || !visorIne?.archivo"
            >
              <mat-icon>credit_card</mat-icon> Ver identificación
            </button>
          </p>

          <br />
          <div class="grid-container">
            <mat-form-field appearance="fill" floatLabel="always">
              <mat-label>BUSCAR</mat-label>
              <input
                matInput
                (keyup)="filtroDataDourceTR($event)"
                placeholder="INGRESE DATO A BUSCAR"
              />
            </mat-form-field>
          </div>

          <table mat-table [dataSource]="dataSourceTR" class="mat-elevation-z8">
            <ng-container matColumnDef="OPCIONES">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <button
                  mat-mini-fab
                  color="primary"
                  matTooltip="Ver asignación a detalle"
                  (click)="
                    clickDetallAsignacion(
                      element.administrador_TI,
                      element.colaborador_id,
                      element.id_registro_asignacion
                    )
                  "
                >
                  <mat-icon>visibility</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="STATUS DE LA ASIGNACIÓN">
              <th mat-header-cell *matHeaderCellDef>STATUS DE LA ASIGNACIÓN</th>
              <td mat-cell *matCellDef="let element">
                {{ element.status_registro }}
              </td>
            </ng-container>

            <ng-container matColumnDef="FECHA ASIGNACIÓN">
              <th mat-header-cell *matHeaderCellDef>FECHA ASIGNACIÓN</th>
              <td mat-cell *matCellDef="let element">
                {{ element.fecha_asignacion_cadena }}
              </td>
            </ng-container>

            <ng-container matColumnDef="FECHA MODIFICACIÓN">
              <th mat-header-cell *matHeaderCellDef>FECHA MODIFICACIÓN</th>
              <td mat-cell *matCellDef="let element">
                {{ element.fecha_modificacion_cadena }}
              </td>
            </ng-container>

            <ng-container matColumnDef="DESCRIPCIÓN DE LA ASIGNACIÓN">
              <th mat-header-cell *matHeaderCellDef>
                DESCRIPCIÓN DE LA ASIGNACIÓN
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.observaciones }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="encabezadosT"></tr>
            <tr mat-row *matRowDef="let row; columns: encabezadosT"></tr>
          </table>
          <mat-paginator
            #paginatorTR
            class="mat-elevation-z8"
            [pageSizeOptions]="[10, 20, 30, 40, 50]"
            showFirstLastButtons
          ></mat-paginator>
        </div>
      </mat-tab>

      <mat-tab label="EQUIPOS">
        <div class="inicio">
          <p class="titulo">
            {{ nombre }} {{ apellidos }}
            <button
              mat-mini-fab
              color="primary"
              (click)="clickMasInformacionV3($event)"
              matTooltip="Click para más información"
            >
              <mat-icon>info</mat-icon>
            </button>
            <br />
            <button
              mat-raised-button
              color="primary"
              matTooltip="Ver INE"
              (click)="sidenav.toggle()"
              [disabled]="!id_empleado || !visorIne?.archivo"
            >
              <mat-icon>credit_card</mat-icon> Ver identificación
            </button>
          </p>

          <br />
          <div class="grid-container">
            <mat-form-field appearance="fill" floatLabel="always">
              <mat-label>BUSCAR</mat-label>
              <input
                matInput
                (keyup)="filtroDataDourceTE($event)"
                placeholder="Ingrese el nombre, modelo, tipo o numero de serie a buscar"
              />
            </mat-form-field>
          </div>

          <table mat-table [dataSource]="dataSourceTE" class="mat-elevation-z8">
            <ng-container matColumnDef="OPCIONES">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <button
                  mat-mini-fab
                  color="warn"
                  matTooltip="Cancelar asignación de este equipo"
                  (click)="
                    clickCancelarAsignacionEquipo(
                      element.id,
                      element.tabla,
                      element.tipo,
                      element.name
                    )
                  "
                >
                  <mat-icon>cancel</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="NOMBRE">
              <th mat-header-cell *matHeaderCellDef>NOMBRE</th>
              <td mat-cell *matCellDef="let element">{{ element.name }}</td>
            </ng-container>

            <ng-container matColumnDef="TIPO">
              <th mat-header-cell *matHeaderCellDef>TIPO</th>
              <td mat-cell *matCellDef="let element">{{ element.tipo }}</td>
            </ng-container>

            <ng-container matColumnDef="MODELO">
              <th mat-header-cell *matHeaderCellDef>MODELO</th>
              <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
            </ng-container>

            <ng-container matColumnDef="MARCA">
              <th mat-header-cell *matHeaderCellDef>MARCA</th>
              <td mat-cell *matCellDef="let element">
                {{ element.manufacturers_id }}
              </td>
            </ng-container>

            <ng-container matColumnDef="NÚM. SERIE">
              <th mat-header-cell *matHeaderCellDef>NÚM. SERIE</th>
              <td mat-cell *matCellDef="let element">{{ element.serial }}</td>
            </ng-container>

            <ng-container matColumnDef="LOCACION">
              <th mat-header-cell *matHeaderCellDef>LOCACION</th>
              <td mat-cell *matCellDef="let element">
                {{ element.locations_id }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="encabezadosE"></tr>
            <tr mat-row *matRowDef="let row; columns: encabezadosE"></tr>
          </table>
          <mat-paginator
            #paginatorTE
            class="mat-elevation-z8"
            [pageSizeOptions]="[10, 20, 30, 40, 50]"
            showFirstLastButtons
          ></mat-paginator>
        </div>
      </mat-tab>

      <mat-tab label="CREAR RESPONSIVA GENERAL">
        <div class="inicio">
          <p class="titulo">
            {{ nombre }} {{ apellidos }}
            <button
              mat-mini-fab
              color="primary"
              (click)="clickMasInformacionV4($event)"
              matTooltip="Click para más información"
            >
              <mat-icon>info</mat-icon>
            </button>
            <br />
            <button
              mat-raised-button
              color="primary"
              matTooltip="Ver INE"
              (click)="sidenav.toggle()"
              [disabled]="!id_empleado || !visorIne?.archivo"
            >
              <mat-icon>credit_card</mat-icon> Ver identificación
            </button>
          </p>

          <div class="grid-container3">
            <mat-form-field appearance="fill">
              <mat-label>Sucursal</mat-label>
              <mat-select
                [formControl]="select_sucursal"
                (selectionChange)="clickCargarSucursal($event)"
                required
              >
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="input_sucursal_nombre"
                    oninput="this.value = this.value.toUpperCase()"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="let option of listaFiltradaSucursales | async"
                  [value]="option"
                >
                  {{ option.nombreSucursal }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="example-full-width" appearance="fill">
              <mat-label>Colaborador que extiende la responsiva</mat-label>
              <mat-progress-bar
                *ngIf="isLoadingEmpleados"
                mode="indeterminate"
              ></mat-progress-bar>
              <input
                type="text"
                matInput
                [formControl]="input__empleado__entrega__equipos"
                [matAutocomplete]="auto2"
                oninput="this.value = this.value.toUpperCase()"
              />
              <mat-autocomplete
                autoActiveFirstOption
                #auto2="matAutocomplete"
                (optionSelected)="
                  clickColaboradorSeleccionado($event.option.value)
                "
              >
                <mat-option
                  *ngFor="let option of listaFiltradaColaboradores | async"
                  [value]="option"
                >
                  {{ option.nomb_compl }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Buscar</mat-label>
              <input
                matInput
                (keyup)="filtroDataDource($event)"
                placeholder="Ingrese el equipo a buscar"
                oninput="this.value = this.value.toUpperCase()"
              />
            </mat-form-field>
          </div>

          <div class="example-button-row">
            <button
              mat-raised-button
              color="accent"
              matTooltip="Carga la responsiva general al sistema"
              (click)="clickSubirResponsivaGeneral($event)"
            >
              Subir <mat-icon>unarchive</mat-icon>
            </button>
            <button
              mat-raised-button
              color="primary"
              matTooltip="Genera y descarga la responsiva general"
              [disabled]="!habilitarbtnResponsivaGeneral()"
              (click)="descargarResponsivaGeneral()"
            >
              Descargar <mat-icon>download</mat-icon>
            </button>
          </div>
          <table mat-table [dataSource]="dataSourceES" class="mat-elevation-z8">
            <ng-container matColumnDef="OPCIONES">
              <th mat-header-cell *matHeaderCellDef>
                <div class="example-button-row">
                  <mat-checkbox
                    class="example-margin"
                    [(ngModel)]="selectTodos"
                    [disabled]="!habilitarCheckAll()"
                    (change)="checkAll($event.checked)"
                  ></mat-checkbox>
                </div>
              </th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox
                  class="example-margin"
                  [(ngModel)]="element.bandera"
                ></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="NOMBRE">
              <th mat-header-cell *matHeaderCellDef>NOMBRE</th>
              <td mat-cell *matCellDef="let element">{{ element.name }}</td>
            </ng-container>

            <ng-container matColumnDef="TIPO">
              <th mat-header-cell *matHeaderCellDef>TIPO</th>
              <td mat-cell *matCellDef="let element">{{ element.tipo }}</td>
            </ng-container>

            <ng-container matColumnDef="MODELO">
              <th mat-header-cell *matHeaderCellDef>MODELO</th>
              <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
            </ng-container>

            <ng-container matColumnDef="MARCA">
              <th mat-header-cell *matHeaderCellDef>MARCA</th>
              <td mat-cell *matCellDef="let element">
                {{ element.manufacturers_id }}
              </td>
            </ng-container>

            <ng-container matColumnDef="NÚM. SERIE">
              <th mat-header-cell *matHeaderCellDef>NÚM. SERIE</th>
              <td mat-cell *matCellDef="let element">{{ element.serial }}</td>
            </ng-container>

            <ng-container matColumnDef="LOCACION">
              <th mat-header-cell *matHeaderCellDef>LOCACION</th>
              <td mat-cell *matCellDef="let element">
                {{ element.locations_id }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="encabezadosE"></tr>
            <tr mat-row *matRowDef="let row; columns: encabezadosE"></tr>
          </table>
          <mat-paginator
            #paginatorES
            class="mat-elevation-z8"
            [pageSizeOptions]="[10, 20, 30, 40, 50]"
            showFirstLastButtons
          ></mat-paginator>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-sidenav-content>
</mat-sidenav-container>
